export const INIT_SEARCH_VACANCIES_COUNT = 20;
export const DROPDOWN_SINGLE_SEARCH_LIST_COUNT = 20;
export const DROPDOWN_MULTI_SEARCH_LIST_COUNT = 4;
